/* istanbul ignore file */
import PropTypes from 'prop-types';

const APIDataShape = PropTypes.shape({
  achCompany: PropTypes.shape({}).isRequired,
  dateSettings: PropTypes.shape({
    achCalendarResponse: PropTypes.shape({
      holidays: PropTypes.arrayOf(PropTypes.string),
      businessDaysOfWeek: PropTypes.arrayOf(PropTypes.number),
      earliestDayForACH: PropTypes.string,
      latestDayForACH: PropTypes.string
      // nonEligibleSameDayDates: []
    }),
    canUnlock: PropTypes.bool,
    activationTimeResponseList: PropTypes.arrayOf(
      PropTypes.shape({
        activationTimeId: PropTypes.number,
        activationTime: PropTypes.string
      })
    ),
    editable: PropTypes.bool,
    sameDayEligible: PropTypes.bool,
    recurringPaymentsEnabled: PropTypes.bool
  }).isRequired,
  payees: PropTypes.arrayOf(
    PropTypes.shape({
      contactPerson: PropTypes.string,
      companyId: PropTypes.string,
      customerNumber: PropTypes.string,
      email1: PropTypes.string,
      email2: PropTypes.string,
      fax: PropTypes.string,
      id: PropTypes.number,
      lastModified: PropTypes.string,
      mobile: PropTypes.string,
      name: PropTypes.string,
      nickName: PropTypes.string,
      phone: PropTypes.string,
      status: PropTypes.string,
      type: PropTypes.arrayOf(PropTypes.string)
    })
  )
});

export default APIDataShape;
